import type { ShowConfirmOptions, ShowToastOptions } from './types';

type ToastHandler = (options: ShowToastOptions) => string;
type ConfirmHandler = (options: ShowConfirmOptions) => Promise<boolean>;

let toastHandler: ToastHandler | null = null;
let confirmHandler: ConfirmHandler | null = null;

export function registerNotificationHandlers(handlers: {
  showToast: ToastHandler;
  showConfirm: ConfirmHandler;
}): void {
  toastHandler = handlers.showToast;
  confirmHandler = handlers.showConfirm;
}

export function unregisterNotificationHandlers(): void {
  toastHandler = null;
  confirmHandler = null;
}

/** Imperative toast API — works from React components and utility modules. */
export function showToast(options: ShowToastOptions): string {
  if (!toastHandler) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[notifications] showToast chamado antes do NotificationProvider.', options);
    }
    return '';
  }
  return toastHandler(options);
}

/** Imperative confirm API — returns true when the user confirms. */
export function showConfirm(options: ShowConfirmOptions): Promise<boolean> {
  if (!confirmHandler) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[notifications] showConfirm chamado antes do NotificationProvider.', options);
    }
    return Promise.resolve(false);
  }
  return confirmHandler(options);
}

export function toastSuccess(title: string, message?: string, duration?: number): string {
  return showToast({ type: 'success', title, message, duration });
}

export function toastError(title: string, message?: string, duration?: number): string {
  return showToast({ type: 'error', title, message, duration });
}

export function toastWarning(title: string, message?: string, duration?: number): string {
  return showToast({ type: 'warning', title, message, duration });
}

export function toastInfo(title: string, message?: string, duration?: number): string {
  return showToast({ type: 'info', title, message, duration });
}
